import { Component, OnInit, ViewChild } from '@angular/core';
import { NavParams, PopoverController, ToastController, IonSlides, LoadingController } from '@ionic/angular';
import { PedidoService } from 'src/app/servicios/pedido/pedido.service';
import { ProductoService } from 'src/app/servicios/producto.service';

import { AgregaraudioComponent } from '../agregaraudio/agregaraudio.component';
import { Router } from '@angular/router';
//const MicRecorder = require('mic-recorder-to-mp3');

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss'],
})

export class ProductoComponent implements OnInit {
 
  @ViewChild('IonSlides') slides: IonSlides;
   
  constructor(public navParams:NavParams, public poper: PopoverController, private toastController: ToastController,
              public popoverController: PopoverController, public pedidoService: PedidoService, public router: Router,
              public productoService: ProductoService, public loadingController: LoadingController) {
    this.producto = this.navParams.get('caja');
    this.producto = this.producto.motivo;  
    this.sliderConfig = {
      initialSlide: 0,
      speed: 400,
      slidesPerView: 1,
      autoplay: false,
      zoom:{maxRatio: 2},
      autoHeight: true,
      pager:true
    };
    const _this = this; // 'this' inside 'subscribe' refers to the observable object
    console.log("producto: "+this.producto);
    if (this.producto == "peluche") {
      this.json = pedidoService.peluches;
    } else if (this.producto == "accesorio") {
      this.json = this.pedidoService.accesorios;  
    }
    
 
   
   }
   listaProductos;
producto;
  
  json=[];
  articulo;   
  async aceptarPopOver(imagen){
    this.poper.dismiss({      
      imagen : this.articulo
    });
  
  }

  async cerraPopOver(){    
    this.poper.dismiss({      
    });
  
  }
  agregaraCaja(id, imagen, precio, nombre, value, descripcion, largo, posicion, medida){   
    console.log("nombre: "+nombre+" id: "+id+" imagen: "+imagen+" precio: "+precio+" descripcion: "+descripcion+" largo: "+largo+" posicion: "+posicion+" medida: "+medida); 
    if (value == 1) {
      if ( this.Mifrase == undefined || this.Mifrase == "") {
      this.Mifrase = "";
      this.productoService.nuevoProducto(id,nombre, this.Mifrase, 1, precio, imagen , value, descripcion, largo, nombre, posicion);
      this.mostrarToast(nombre, 'success');
    }else{
      this.productoService.nuevoProducto(id,nombre, this.Mifrase, 1, precio, imagen , value, descripcion, largo, nombre, posicion);
      this.mostrarToast(nombre, 'success');
    }
    }
    if (value == 2 || value == 0) {
      this.abrirPeluche(id, imagen, precio, descripcion, nombre, value, medida);
    }
   /*  if (value == 0) {
      this.Mifrase = "";
      this.productoService.nuevoProducto(id,nombre, this.Mifrase, 1, precio, imagen, value, descripcion, largo, nombre, posicion);
      this.mostrarToast(nombre, 'success');
    } */
    
    //this.articulo = ;
    this.poper.dismiss();
  }


  async DismissClick() {
    await this.poper.dismiss();
      }

      frase(event){
        this.Mifrase = event.detail.value;
        }
        Mifrase;

//GRABAR AUDIO
grabarAudio(){}

async abrirPeluche(id, url, precio, descripcion, nombre, value, medida) {

  const loading = await this.loadingController.create({
    message: "ʕ•́ᴥ•̀ʔっ"
  });
  await loading.present();

  this.router.navigate(['/agregaraudio'],
    { queryParams: {id: id, imagen: url, precio: precio, descripcion: descripcion, nombre: nombre, value: value, medida: medida} }
  );

  loading.dismiss();
}

async mostrarToast(producto, color: 'success' | 'danger' | 'warning') {
  const toast = await this.toastController.create({
    message: "¡Bien!, has agregado un "+producto,
    position: 'bottom',
    duration: 2000,
    color: color
  });
  toast.present();
}

//////////////////////////////////////////////////////////////////////////////
//Stop the slide autoplay when the view will leave
sliderConfig;
showSlides=false;
public ionViewWillEnter(){
 if (this.slides != undefined) {
   this.slides.update();
 }  
}

ngOnInit() {
  setTimeout (() => {
    this.showSlides = true;
    }, 0);    
}
async cerarPopOver(){  
  this.poper.dismiss(); 
}
////////////////////////////////////////////////////////////////////////////////
}
